import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.primary ? '' : 'mt-2 grey--text text--darken-1 caption',attrs:{"to":_vm.to,"exact":""}},[_c(VIcon,{staticClass:"mr-2",attrs:{"small":"","color":_vm.primary ? 'primary' : ''}},[_vm._v("$arrow-left-line")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }